export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12830.0eb09439.jpg";